class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.isMouseOverCart = false;  // Initialize the new property
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    this.miniCartElement = document.getElementById('mini-cart'); // Get the mini-cart element

    // Add event listeners for mouseenter and mouseleave on mini-cart
    this.miniCartElement.addEventListener('mouseenter', () => {
      this.isMouseOverCart = true;
    });

    this.miniCartElement.addEventListener('mouseleave', () => {
      this.isMouseOverCart = false;
    });

    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        this.miniCartElement.innerHTML = this.getSectionInnerHTML(html, '.shopify-section');
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }

    this.drawer.openMenuDrawer();

    // Check if the viewport width is greater than 768px (not mobile)
    if (window.innerWidth > 768) {
        setTimeout(function(){
          if (!this.isMouseOverCart) {
            this.drawer.closeMenuDrawer(new CustomEvent('close'));
          }
        }.bind(this), 8000);
    }
}

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
